<template>
    <div class="page" :style="{'--styleColor': style.style_color, backgroundImage:'url('+ style.bg_other +')'}">
      <div class="topBanner"></div>
      <div class="mainBox">
        <div class="video-container">
          <div id="video" class="video" style="width: 100%;height:100%;"></div>
        </div>
        <div class="title" v-show="infoData.title">{{infoData.title}}</div>
        <div class="author" v-show="infoData.author">{{infoData.author}}</div>
        <div class="content" v-html="infoData.content"></div>
        <div class="navBox">
          <div class="navTxt" @click="toHome"><i class="iconfont icon-zhuye"></i>首页</div>
          <div class="navTxt" @click="toMyCenter"><i class="iconfont icon-wode1"></i>个人中心</div>
        </div>
      </div>
     
    </div>
  </template>
  
  <script> 
  import {reqLine,reqScore} from '@/api/index' //动态接口
  import {reqLession} from '@/api/index2' //静态接口
  //分享
  import { wxShare } from '@/utils/wxshare-wes2.com.js'
  import zonglan from '@/utils/cp-zonglan.js'

  export default {
    name: 'show',
    components: {
  
    },
    data () {
      return {
        learnid:0,
        token:"",
        accountId:'',
        uniqueId:'',
        lessionid:0,
        infoData:[],
        shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
        shareTitle:"",
        shareDesc:"", 
        style:{},
      }
    },
    computed: {},
    created (){
      this.learnid = this.$route.query.learnid;
      if(this.$route.query.hasOwnProperty("id")){
        this.lessionid = this.$route.query.id;
      }else{
        this.$toast({
          icon: 'warning-o',
          message: "您访问的信息错误或不存在"
        });
      }
      this.token = this.$store.state.token;
      this.accountId = this.$store.state.accountId;
      this.uniqueId = this.$store.state.uniqueId;
      this.shareImg = this.$store.state.actInfo.share_img;
      this.shareTitle = this.$store.state.actInfo.share_title;
      this.shareDesc = this.$store.state.actInfo.share_desc;
      this.style = this.$store.state.actInfo.style;
    },
    mounted () {      
      this.getLession()  
      zonglan.pageShare(0,'',this.shareImg,this.shareTitle,this.shareDesc);
    },    
    methods: {
        toHome(){
          this.$router.push({ path: '/list',query:this.$route.query })
        },
        toMyCenter(){
          this.$router.push({ path: '/mycenter',query:this.$route.query })
        } ,
        async getLession() {
          let result = await reqLession({lessionid:this.lessionid});
          if(result.flag=='success') {
              console.log(result.data);
              this.infoData = result.data;
              this.loadCkplayer()
          } else {
            this.$toast({
              icon: 'warning-o',
              message: result.message
            });
          }            
        },
        async setLine(){
          let result = await reqLine({learnid:this.learnid,lessionid:this.lessionid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId});
          if(result.flag=='success'){
            console.log(result.message);     
            localStorage.setItem('isClick_'+this.lessionid+'_'+this.accountId,1);
          } else {
            this.$toast({
              icon: 'warning-o',
              message: result.message
            });
          }
        },
        async setScore(){
          let result = await reqScore({learnid:this.learnid,lessionid:this.lessionid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId});
          if(result.flag=='success'){
            //更新本地已观看数据
            let viewed = localStorage.getItem(this.learnid+'_viewed');
            let status = viewed.split(',').includes(this.lessionid);
            if(!status){
              if(viewed==''){
                localStorage.setItem(this.learnid+'_viewed',this.lessionid);
              } else {
                localStorage.setItem(this.learnid+'_viewed',viewed+','+this.lessionid);
              }              
            }

            this.$toast({
              icon: 'warning-o',
              message: result.message
            });

          } else {
            this.$toast({
              icon: 'warning-o',
              message: result.message
            });
          }
        },
        loadCkplayer(){
            let seekTime = localStorage.getItem('lession_'+this.lessionid);
            seekTime = parseFloat(seekTime);
            console.log('seekTime',seekTime);
            let videoObject = {
                    container: '#video',//视频容器的ID
                    // video: 'https://video.hebnews.cn/asset/ff03be35e4fde9432fb91d2f10c9c50a/play_video/df633c7ec1410db752346a78ce6b2982_0.mp4',//视频地址
                    video: [
                            [this.infoData.video_standard, 'video/mp4', '标清'],
                            [this.infoData.videourl, 'video/mp4', '高清']
                        ],
                    volume: 0.8,//默认音量，范围0-1
                    poster: this.infoData.thumb,//封面图片地址
                    autoplay: false,//是否自动播放
                    loop: false,//是否需要循环播放
                    rotate:0,//视频旋转角度
                    zoom:0,//默认缩放比例
                    live: false,//是否是直播
                    ad:null,//广告
                    backLive:false,//显示返回直播按钮
                    seek: seekTime,//默认需要跳转的秒数
                    next: null,//下一集按钮动作
                    loaded: '',//加载播放器后调用的函数
                    plug:'',//使用插件，目前支持hls.js:用于在pc端播放m3u8，flv.js:播放flv，mpegts.js：播放ts
                    duration:0,//如果强制使用点播，而视频里不存在总时间，可以手动指定
                    preview: null,//预览图片对象
                    prompt: null,//提示点功能
                    crossOrigin:'',//发送跨域信息，示例：Anonymous            
                    type:'',//视频类型
                    playbackrate: 1,//默认倍速
                    ended:null,//结束显示的内容
                    webFull:false,//是否启用页面全屏按钮，默认不启用
                    theatre:null,//是否启用剧场模式按钮，默认不启用
                    controls:false,//是否显示自带控制栏
                    rightBar:null,//是否开启右边控制栏
                    smallWindows:null,//是否启用小窗口模式
                    smallWindowsDrag:true,//小窗口开启时是否可以拖动
                    screenshot:false,//截图功能是否开启
                    timeScheduleAdjust:5,//是否可调节播放进度,0不启用，1是启用，2是只能前进（向右拖动），3是只能后退，4是只能前进但能回到第一次拖动时的位置，5是看过的地方可以随意拖动
                    logo:'',//logo
                    menu:null,//右键菜单
                    information:{//关于
                    'Load:':'{loadTime} second',
                    'Duration:':'{duration} second',
                    'Size:':'{videoWidth}x{videoHeight}',
                    'Volume:':'{volume}%',
                    'Sudio decoded:':'{audioDecodedByteCount} Byte',
                    'Video decoded:':'{videoDecodedByteCount} Byte'
                    },
                    track:null,//字幕
                    title:'',//视频标题
                    language:'',//语言包文件
                    barHideTime:500,//控制栏隐藏时间
                    playbackrateOpen:true,//是否开启控制栏倍速选项
                    playbackrateList:[1,1.25,1.5,2],//倍速配置值
                    cookie:'lession_'+this.lessionid,//cookie名称，在同一域中请保持唯一
                    looked:'lession_watched_',
                    domain:null,//cookie保存域
                    cookiePath:'/',//cookie保存路径
                    documentFocusPause:false,//窗口失去焦点后暂停播放
                    mouseWheelVolume:2,//是否启用鼠标滚轮调节音量功能，0=不启用，1=启用，2=全屏时才启用
                    keyVolume:2//是否启用键盘控制音量调节，0=不启用，1=启用，2=全屏时才启用
                };
            this.player = new ckplayer(videoObject); //初始化播放器

            // //定位至播放时间且seek的状态为seeked后，再禁止拖动进度条
            let _this = this;            

            //监听到播放
            this.player.play(function () {
                console.log('监听到播放');

                var time = localStorage.getItem(videoObject.cookie);
                _this.player.vars('timeScheduleAdjust',1);                
                _this.player.seek(time);
                _this.player.seek(function(obj){
                  console.log(obj);
                  if(obj['state']==="seeked") {//设定记忆播放时间结束
                    _this.player.vars('timeScheduleAdjust',5);//禁止拖动
                  }		
                });

                if(!localStorage.getItem('isClick_'+_this.lessionid+'_'+_this.token)){
                  _this.setLine() //设置时间线
                }                
            });

            this.player.pause(function(){
              _this.player.vars('timeScheduleAdjust',5);//禁止拖动
            })

            //监听到播放结束
            this.player.ended(function(){
              console.log('监听到播放结束');
              console.log('localStorage.getItem(videoObject.cookie)',localStorage.getItem(videoObject.cookie));
              console.log('_this.player.duration()',_this.player.duration());
              if(parseInt(localStorage.getItem(videoObject.cookie))>=parseInt(_this.player.duration())){
                console.log('设定积分');
                //请求后端，验证是否符合观看规则并增加积分
                _this.setScore()
              } else {
                console.log('时长不一致');
              }


            });
        }
    }
    
  }
  </script>
  
  <style lang="scss" scoped>
  .page{
    width: 750px;
    min-height: 1366px;
    font-size: 30px;
    background-repeat: no-repeat;
    background-size: contain;
    .mainBox{
      width: 750px;
      min-height: 1366px;
      background: #fff;
      padding-top: 5px;
    }
    .topBanner{
      width: 750px;
      height: 200px;
      img{
        width: 100%;
        height: auto;
        display: block;
      }
    }
    .title{
      width: 680px;
      height: auto;
      line-height:40px;
      font-size: 30px;
      margin: 0 auto;
      text-align: left;
      font-family: "宋体";
    }
    .author{
      width: 680px;
      height: auto;
      line-height:80px;
      margin: 0 auto;
      text-align: center;
      font-size: 26px;
      color: #4c4c4c;
      border-bottom: 3px solid #e2e2e2;
      font-family: "黑体";
    }
    .content{
      width: 680px;
      height: auto;
      line-height:40px;
      margin: 0 auto;
      text-align:left;
      text-indent: 2em;
      font-size: 26px;
      color: #4c4c4c;
      padding-bottom: 120px;
      p,div{
        width: 100%;
      }
      img{
        width: 90%;
        height: auto;
        margin: 0 auto;
        display: block;
      }
    }
    .navBox{
      position: fixed;
      left: 0px;
      bottom: 0px;
      width: 750px;
      height: 100px;
      background: #f9f9f9;
      border-top: 1px solid #c8c8c8;
      display: flex;
      justify-content: space-evenly;
      font-size: 30px;
      .navTxt{
        padding:0px 50px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #808080;
        font-weight: 400;
        i{
          font-size: 40px;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .video-container{
    width: 710px;
    height: 400px;
    margin: 20px auto;
  }
  </style>